<mat-card class="card">
   <div class="card-header">
      <span>{{ title }}</span>
      <ng-content select="[header-action]"></ng-content>
   </div>
   <mat-card-content class="card-content">
      <div class="detail-right-card">
         <ng-content></ng-content>
      </div>
   </mat-card-content>
</mat-card>
